import React, { FC, useEffect } from "react";
import classNames from "classnames";
import { useAtom } from "jotai";
import moment from "moment";

import { BoldText } from "components/BoldText/BoldText";
import { Button } from "components/Button/Button";
import { HorizontalSpace } from "components/HorizontalSpace/HorizontalSpace";
import { BaseLayout } from "components/BaseLayout/BaseLayout";
import { Divider } from "components/Divider/Divider";

import DaysServices from "utils/days";
import ExcelServices from "utils/excel";

import useReports from "../../hooks/useReports";
import {
  reportsAtom,
  reportsFiltersAtom,
  reportsHeadersAtom,
} from "../../atoms/reportsAtom";

import { Header } from "./Header";
import { Body } from "./Body";
import styles from "./styles.module.scss";

interface BaseReportLayoutLeft {
  title: string;
  isMultiStore?: boolean;
  type: "profit" | "movement";
}

export const BaseReportLayoutLeft: FC<BaseReportLayoutLeft> = ({
  title,
  isMultiStore,
  type,
}): JSX.Element => {
  const [reports, setReports] = useAtom(reportsAtom);
  const [reportsHeaders] = useAtom(reportsHeadersAtom);
  const [, setReportsHeaders] = useAtom(reportsHeadersAtom);
  const [reportsFilters, setReportsFilters] = useAtom(reportsFiltersAtom);

  const { getAndSaveData, getReports } = useReports();

  const onExcelClick = () => {
    if (!reports.length) return;
    let fileName =
      type === "profit" ? "fp-report-profit" : "fp-report-movement";
    fileName +=
      "-" +
      moment(reportsFilters.dateFrom).format("YYYY_MM_DD") +
      "-" +
      moment(reportsFilters.dateTo).format("YYYY_MM_DD");

    ExcelServices.generateFile({
      headers: reportsHeaders,
      data: reports,
      fileName,
    });
  };

  useEffect(() => {
    getAndSaveData().then();
    setReports([]);
    setReportsHeaders([]);
    setReportsFilters({
      dateFrom: DaysServices.getDayStart(new Date()),
      dateTo: DaysServices.getDayEnd(new Date()),
      storeIds: [],
      itemGroupIds: [],
    } as any);
  }, []);

  return (
    <BaseLayout
      className={classNames("ml-2 mt-3 mb-3 px-8" as any)}
      header={<BoldText>{title}</BoldText>}
      width={450}
      footer={
        <div className="flex flex-row justify-between items-center">
          <div className="flex flex-row justify-between items-center">
            <Button onClick={() => getReports(type)} icon="download">
              Сформировать
            </Button>
            <HorizontalSpace size={11} />
            <Button
              onClick={onExcelClick}
              icon="excel"
              disabled={!reports.length}
            >
              Excel
            </Button>
          </div>
        </div>
      }
    >
      <div className={styles.container}>
        <Header isMultiStore={isMultiStore} />
        <Divider marginVertical={14} />
        <Body />
      </div>
    </BaseLayout>
  );
};
